import React, { PropsWithChildren, useEffect } from "react";

interface OwnProps {
  pageTitle?: string;
}

type Props = PropsWithChildren<OwnProps>;

const PageTitleWrapper: React.FC<Props> = (props: Props) => {
  const { children, pageTitle } = props;

  useEffect(() => {
    document.title = `${site.companyName} - ${pageTitle}`;
  }, [site.companyName, pageTitle]);

  return (
    <div>{children}</div>
  );
};

export default PageTitleWrapper;
